export default "__VITE_ASSET__D4EM11ny__"